import { render, staticRenderFns } from "./Pnote.vue?vue&type=template&id=dd56f410&scoped=true&"
import script from "./Pnote.vue?vue&type=script&lang=js&"
export * from "./Pnote.vue?vue&type=script&lang=js&"
import style0 from "./Pnote.vue?vue&type=style&index=0&id=dd56f410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd56f410",
  null
  
)

export default component.exports